import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';

export default function TargetWidget({ targets }) {
  return (
    <Card className="shadow-sm border border-gray-200">
      <CardHeader className="pb-3 border-b bg-gray-50/50">
        <CardTitle className="text-base font-semibold text-gray-800">Targets</CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="space-y-4">
          <div className="flex justify-center space-x-8 mb-6">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-orange-400 rounded"></div>
              <span className="text-xs text-gray-600">Assigned</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded"></div>
              <span className="text-xs text-gray-600">Achieved</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-blue-400 rounded"></div>
              <span className="text-xs text-gray-600">Balance</span>
            </div>
          </div>

          {targets && targets.length > 0 ? (
            targets.map((target, index) => {
              const achieved = target.achieved || 0;
              const assigned = target.assigned || 0;
              const balance = assigned - achieved;
              const percentage = assigned > 0 ? (achieved / assigned) * 100 : 0;

              return (
                <div key={index} className="space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-700">{target.target_type}</span>
                    <Badge variant="outline" className="text-xs">
                      {percentage.toFixed(0)}%
                    </Badge>
                  </div>
                  <div className="flex h-6 overflow-hidden rounded-full bg-gray-100">
                    <div 
                      className="bg-green-500" 
                      style={{ width: `${Math.min(percentage, 100)}%` }}
                    />
                  </div>
                  <div className="flex justify-between text-xs text-gray-500">
                    <span>Assigned: {assigned}</span>
                    <span>Achieved: {achieved}</span>
                    <span>Balance: {balance}</span>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-sm text-gray-500 text-center py-6">No targets set</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}